/* Svensk katalog for locale-pension-invoice-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'otp.sourceRequired': 'Dokument från inkorgen eller befintlig verifikation',
  'otp.positivePremium': 'Pensionspremie större än 0 kr',
  'otp.completeBeforePreview': 'Fyll i eller välj innan du visar konteringsförslaget:',
  'otp.unlinked': 'Löneavsättningar utan fakturakoppling',
  'otp.alreadyPosted': 'Redan bokförd kostnad och betalning',
  'otp.noAccruals': 'Inga tillgängliga löneavsättningar. Redan betalda avsättningar måste korrigeras innan de kan kopplas till en faktura.',
  'otp.inboxNotice': 'Det här ser ut som en pensionsfaktura (OTP). Registrera den via Pension/OTP för att avräkna mot löneavsättningar och hantera arbetsgivaravgiften rätt.',
  'otp.open': 'Öppna i Pension/OTP',
  'otp.dismiss': 'Det här gäller inte OTP',
  'otp.invoices': 'Pensionsfakturor och avräkning',
  'otp.register': 'Registrera pensionsfaktura',
  'otp.flow': 'Koppla fakturan till löneavsättningarna först. Betalning registreras på fakturan en gång. Arbetsgivaravgiften följer faktisk betalningsmånad.',
  'otp.invoice': 'Faktura',
  'otp.actual': 'Faktisk kostnad',
  'otp.accrued': 'Avräknad avsättning',
  'otp.paid': 'Betald',
  'otp.remaining': 'Återstår',
  'otp.aga': 'Arbetsgivaravgift hanterad',
  'otp.reported': 'Rapportering registrerad',
  'otp.notReported': 'Rapportering inte registrerad',
  'otp.reportingReview': 'A-melding måste granskas',
  'otp.reportingWarning': 'Det finns redan en A-melding registrerad för betalningsmånaden. Betalningen kan registreras, men du måste granska och eventuellt korrigera A-meldingen med uppdaterat pensions- och arbetsgivaravgiftsunderlag. Tidigare inlämning ändras inte automatiskt.',
  'otp.annulled': 'Koppling makulerad',
  'otp.details': 'Se detaljer',
  'otp.document': 'Dokument från inkorgen',
  'otp.existing': 'Koppla till befintlig verifikation',
  'otp.supplierName': 'Leverantör',
  'otp.invoiceNumber': 'Fakturanummer',
  'otp.invoiceDate': 'Fakturadatum',
  'otp.dueDate': 'Förfallodatum',
  'otp.date': 'Avräkningsdatum',
  'otp.premium': 'Arbetsgivarens pensionspremie',
  'otp.administration': 'Pensionsadministration (utan moms)',
  'otp.components': 'Bekräfta att beloppen gäller arbetsgivarens premie och eventuell administration av pensionsordningen, utan moms. Arbetstagarandel, flyttavgifter och andra komponenter måste klargöras separat innan det här flödet används.',
  'otp.selectAccruals': 'Välj de löneavsättningar som fakturan gäller',
  'otp.preview': 'Visa konteringsförslag',
  'otp.difference': 'Differens från avsättningen',
  'otp.existingPreview': 'Befintligt köp och betalning behålls. Nedan visas bara avräkning och eventuell omklassificering. Positivt belopp är debet, negativt är kredit.',
  'otp.newPreview': 'Fakturan bokförs på 5950 mot leverantörsskuld 2400. Nedan visas avräkningen av tidigare avsättningar. Positivt belopp är debet, negativt är kredit. Betalning registreras separat.',
  'otp.confirm': 'Bekräfta faktura och avräkning',
  'otp.saved': 'OTP-registreringen är sparad.',
  'otp.purchasePosting': 'Se inköpsverifikation',
  'otp.allocationPosting': 'Se avräkning',
  'otp.paymentDocumented': 'Registrera bara en dokumenterad betalning som inte redan är bokförd. Detta gör ingen banköverföring.',
  'otp.reversePayment': 'Makulera betalning',
  'otp.annulLink': 'Makulera avräkning',
  'otp.annulExplanation': 'Avräkningen och tillhörande arbetsgivaravgift motkonteras. Inköpsfakturan och betalningen behålls. Koppla fakturan på nytt med rätt avsättningar efteråt. Detta ändrar ingen banköverföring.',
});
